// extracted by mini-css-extract-plugin
export var icon = "_sh-0";